import { Component } from '@angular/core';

@Component({
  selector: 'hero-ingredient-view',
  imports: [],
  templateUrl: './hero-ingredient-view.component.html',
  standalone: true,
})
export class HeroIngredientViewComponent {

}
